module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight-60b79c8b438f699748e3db571f2f68df.png";